const newCaseStyle = {
  dialogWrapper: {
    height: "90%",
    "& .MuiTypography-h2": {
      fontSize: "22px",
      fontWeight: "600",
      color: "#525759"
    },
    "& .MuiTypography-h3": {
      fontSize: "16px",
      fontWeight: "600",
      color: "#525759",
      marginBottom: "10px"
    },
    "& .MuiTypography-h4": {
      fontSize: "14px",
      fontWeight: "500"
    },
    "& .MuiTypography-h5": {
      fontSize: "13px",
      fontWeight: "500",
      color: "rgba(0, 0, 0, 0.4)",
      marginBottom: "8px"
    },
    "& .MuiDialogTitle-root": {
      padding: "40px 17px",
      paddingBottom: "0px"
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
      overflow: "hidden"
    },
    "& .MuiDialogActions-root": {
      padding: "0px"
    }
  },
  verticalGap: {
    marginTop: "15px"
  },
  smallFont: {
    fontSize: "small"
  },
  smallGap: {
    marginLeft: "5px"
  },
  largeGap: {
    marginLeft: "15px"
  },
  caseDetailTitle: {
    backgroundColor: "#4a4a4a",
    color: "white",
    padding: "16px 32px !important"
  },
  caseTitleId: {
    fontSize: "small",
    color: "#929292"
  },
  componentFilter: {
    height: "30px",
    width: "100%",
    "& .MuiAutocomplete-tag": {
      fontSize: "small",
      maxWidth: "calc(79%)",
      height: "23px"
    },
    "& .MuiInput-underline:before": {
      border: "none"
    },
    "& .MuiChip-root": {
      height: "23px"
    },

    "& .MuiAutocomplete-inputFocused": {},
    "& .MuiChip-label": {
      height: "32px"
    },
    "& .MuiAutocomplete-inputRoot": {
      height: "26px"
    }
  },
  listClass: {
    fontSize: "small"
  },
  customChip: {
    height: "22px",
    "& .MuiChip-deleteIcon": {
      height: "17px"
    }
  },
  removePadding: {
    padding: "0px !important"
  },
  removePaddingTop: {
    paddingTop: "0px !important"
  },
  closeButton: {
    color: "#ffffff",
    opacity: "0.4"
  },
  cancel: {
    backgroundColor: "#4a4a49",
    height: "64px"
  },
  cancelButton: {
    color: "#ffffff",
    lineHeight: "52px",
    width: "100%",
    padding: "6px 25px",
    "& .MuiButton-label": {
      justifyContent: "left",
      display: "inline-block",
      textAlign: "right",
      textTransform: "none"
    }
  },
  complate: {
    backgroundColor: "#009343",
    height: "64px"
  },
  complateButton: {
    color: "#ffffff",
    lineHeight: "52px",
    marginLeft: "8px",
    width: "100%",
    padding: "6px 25px",
    "& .MuiButton-label": {
      justifyContent: "left",
      display: "inline-block",
      textAlign: "right",
      textTransform: "none"
    }
  },
  colorWhite: {
    color: "white !important"
  },
  fullWidth: {
    width: "100%"
  },
  scrollbarWrapper: {
    position: "relative",
    height: "100%",
    backgroundColor: "#fafafa"
  },
  createDiagnosisWrapper: {
    padding: "25px 17px",
    backgroundColor: "white"
  }
};

export default newCaseStyle;
